import homeplate from '../../../style/images/bg_homeplate.png'
import homeplate2 from '../../../style/images/base.png'
import zoneborder from '../../../style/images/red_border.png'
import field from '../../../style/images/bg_hitter_line.png'
import field2 from '../../../style/images/bg_field.jpg'
import zone from '../../../style/images/277415.png'
import { getDecimalData } from '../../../Utils/utilFuncs'

export const SpeedOptions = {
  aspectRatio: 0.9,
  layout: {
    padding: {
      top: 40, right: -750
    }
  },
  elements: {
    point: {
      pointRadius: 0,                      
    },
    line: {
      borderWidth: 2,
      tension: 0.4,
      fill: true,
    }
  },
  responsive: true,
  plugins: {
    legend: false,
    tooltip: false,
    datalabels: false
  },
  scales: {
    x: {
      type: "linear",
      min: 100,
      max: 165,
      ticks: {
        stepSize: 5, display: true,
        callback: function (val, index) {
          // Hide every 2nd tick label
          return val >= 110 && val < 165 && index % 2 === 0 ? this.getLabelForValue(val) : "";
        },
      },
      title: {
        display: true,
        text: 'KPH',
        align: 'end',
      },
      grid: {
        drawBorder: false,
        color: function (context) {
          if (context.tick.value >= 110 && context.tick.value < 165)
            return '#EEEEEE';
          else
            return '#EEEEEE00';
        },
      },
    },
    y0: {
      type: 'category',
      position: 'left',
      stack: 'type',
      ticks: { display: true, labelOffset: -20, crossAlign: 'near', padding: 0, mirror: false, z: 10 },
      labels: [["   　AVG", "%  KPH"]],
    },
    r1: {
      type: 'category',
      position: 'right',
      display: true,
      offset: false,
      stack: 'right',
      ticks: { display: true, mirror: true, align: "end" },
      labels: [20 + "%", "0%"],
      title: { display: false },
      grid: {
        drawBorder: false,
        borderWidth: 0,
        drawOnChartArea: false
      },
    },
  }
}

export const SpinDirectionOptions = {
  hoverBorderWidth:0,
  onHover:null,
  responsive: true,    
  aspectRatio:0.9,               
  plugins: {
    legend: false,
    tooltip: false,
    datalabels: false
  },
  scales: {
    r: {      
      startAngle:0, 
      ticks: {display:false},                 
      pointLabels: {                          
      display: true,
      centerPointLabels: false,
      font: {
        size: 14
        }
      },
      grid: {
        display: false,
      },
      angleLines: {
        display: true,
        color: '#CCCCCC'
      },
    },                   
  }
}

export const MovementOptions = {
  responsive: true,
  aspectRatio: 0.9,
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
    },
    tooltip: false,
    datalabels: false
  },
  elements: {
    point: {
      pointRadius: 5,
    },
  },
  scales: {
    x: {
      min: -25,
      max: 25,
      ticks: { display: true, stepSize: 5, },
      title: {
        display: true,
        text: "水平位移",
        font: {
          size: 14
        }
      },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: false,
        borderWidth: 0,
      },
    },
    y: {
      min: -25,
      max: 25,
      ticks: { display: true, stepSize: 5, },
      title: {
        display: true,
        text: "垂直位移",
        font: {
          size: 14
        }
      },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: false,
        borderWidth: 0,
      },
    },
  }
}

let image = new Image()
image.src = homeplate
export const ReleasePointConfig = {
  plugins: [{
    id: 'custom_canvas_background_image',
    beforeDraw: (chart) => {
      if (image.complete) {
        const ctx = chart.ctx;
        const { top, left, width, height } = chart.chartArea;
        
        var image_rwd_width = window.innerWidth * image.width * 1.65 / 1920;
        var image_rwd_height = window.innerWidth * image.height * 1.65 / 1920;
        const x = left + width / 2 - image_rwd_width / 2;
        const y = top + height;
        ctx.drawImage(image, x, y, image_rwd_width, image_rwd_height);
      } else {
        image.onload = () => chart.draw();
      }
    }
  }],
  options: {
    responsive: true,
    aspectRatio: 1.05,
    layout: {
      padding: {
        bottom: 100,
      },
    },
    legend: {
      position: 'left',
      display: false
    },
    plugins: {
      legend: {
        display: false,
        position: 'bottom',
      },
      tooltip: false,
      datalabels: false
    },
    elements: {
      point: {
        pointRadius: 2,
      },
    },
    scales: {
      x: {
        min: -135,
        max: 135,
        ticks: { display: false, stepSize: 20, },
        grid: {
          display: false,
          borderWidth: 0
        },
      },
      y: {
        min: 0,
        max: 200,
        ticks: {
          display: true, stepSize: 20,
          callback: function (val, index) {
            return (val <= 180 || val >= 0) && index%2===0 ? val + " cm" : "";
          }
        },
        grid: {
          display: true,
        },
      },
    }
  }
}

export const ReleaseHeightTrendOptions = {
  aspectRatio: 1.1,
  responsive: true,
  legend: {
    position: 'left',
    display: false
  },
  plugins: {
    legend: {
      display: false,
      position: 'chartArea',
    },
    tooltip: false,
    datalabels: false
  },
  elements: {
    point: {
      pointRadius: 4,
    },
    line: {
      borderWidth: 2,
    }
  },
  scales: {
    x: {
      type: "linear",
      min: 0,
      suggestMax: 50,
      ticks: {
        stepSize: 1, display: true,
        callback: function (val, index) {
          return val === 0 ? "" : val;
        }
      },
      title: {
        display: true,
        text: 'Pitch',
        align: 'end',
      },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: true,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
    y: {
      suggestMin: 0,
      suggestMax: 200,
      ticks: {
        display: true,
        stepSize: 5,
        callback: function (val, index) {
          return (val <= 180 || val >= 0)? val + " cm":""
        }
      },
      grid: {
        drawTicks: false,
        drawBorder: true,
        tickWidth: 0,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
  }
}

export const SpinTrendOptions = {
  aspectRatio: 1.1,
  responsive: true,
  legend: {
    position: 'left',
    display: false
  },
  plugins: {
    legend: {
      display: false,
      position: 'chartArea',
    },
    tooltip: false,
    datalabels: false
  },
  elements: {
    point: {
      pointRadius: 4,
    },
    line: {
      borderWidth: 2,
    }
  },
  scales: {
    x: {
      type: "linear",
      min: 0,
      suggestMax: 15,
      ticks: {
        stepSize: 1, display: true,
        callback: function (val, index) {
          return val === 0 ? "" : val;
        }
      },
      title: {
        display: true,
        text: 'Pitch',
        align: 'end',
      },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: true,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
    y: {
      suggestMin: 1000,
      suggestMax: 3200,
      ticks: {
        display: true,
        stepSize: 50,
        callback: function (val, index) {
          return (val <= 3200 || val >= 1000)? val + " R":""
        }
      },
      grid: {
        drawTicks: false,
        drawBorder: true,
        tickWidth: 0,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
  }
}

export const MovementTrendOptions = {
  aspectRatio: 1.1,
  responsive: true,
  legend: {
    position: 'left',
    display: false
  },
  plugins: {
    legend: {
      display: false,
      position: 'chartArea',
    },
    tooltip: false,
    datalabels: false
  },
  elements: {
    point: {
      pointRadius: 4,
    },
    line: {
      borderWidth: 2,
    }
  },
  scales: {
    x: {
      type: "linear",
      min: 0,
      suggestMax: 15,
      ticks: {
        stepSize: 1, display: true,
        callback: function (val, index) {
          return val === 0 ? "" : val;
        }
      },
      title: {
        display: true,
        text: 'Pitch',
        align: 'end',
      },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: true,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
    y: {
      suggestMin: -40,
      suggestMax: 40,
      ticks: {
        display: true,
        stepSize: 5,
        callback: function (val, index) {
          return (val <= 40 || val >= -40)? val:""
        }
      },
      grid: {
        drawTicks: false,
        drawBorder: true,
        tickWidth: 0,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
  }
}

let plateImage = new Image(), borderImage = new Image()
plateImage.src = homeplate2
borderImage.src = zoneborder
export const KZoneConfig = {
  plugins: [
    {
      id: 'custom_canvas_base_image',
      beforeDraw: (chart) => {
        if (plateImage.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
          var image_rwd_width = 1.25 * window.innerWidth * plateImage.width / 1920;
          var image_rwd_height = 1.25 * window.innerWidth * plateImage.height / 1920;
          const x = left + width / 2 - image_rwd_width / 2;
          const y = top + height - image_rwd_height - (21.5 * window.innerWidth / 1920);
          ctx.drawImage(plateImage, x, y, image_rwd_width, image_rwd_height);
        } else {
          plateImage.onload = () => chart.draw();
        }
      }
    },
    {
      id: 'custom_canvas_red_border_image',
      beforeDraw: (chart) => {
        if (borderImage.complete) {
          const ctx = chart.ctx;
          const {top, left, width, height} = chart.chartArea;
          var image_rwd_width= 1.25 * window.innerWidth * borderImage.width/1920;
          var image_rwd_height= 1.25 * window.innerWidth * borderImage.height/1920;
          const x = left + width / 2 - image_rwd_width / 2;
          const y = top + height /2 - image_rwd_height / 2 - (17.5 * window.innerWidth / 1920);
          ctx.drawImage(borderImage, x, y,image_rwd_width,image_rwd_height);
        } else {
          borderImage.onload = () => chart.draw();
        }
      }
    }
  ],
  options: {
    responsive: true,  
    aspectRatio: 0.95,
    layout: {
      padding: {
        bottom: 60,
      },
    },
    legend: {
      position: 'left',
      display: false
    },
    plugins: {
      legend: false,
      datalabels: {
        align: 'end',
        color: 'white',
        font: {
          size: 10,
          weight: 1000,
        },
        textAlign: 'center',
        anchor: 'end',
        offset: -18.5,
        textStrokeColor: 'black',
        textStrokeWidth: 1,
        formatter: (value) => {
          return value.n
        }
      },
      tooltip: {
        display: true,
        padding: 9,
        callbacks: {
          label: (context) => (context.label+' '+context.raw.v)
        },
      },
    },
    elements: {
      point: {
        pointRadius: 8,
        hoverRadius: 0
      },
    },
    scales: {
      x: {
        min: -40,
        max: 40,
        ticks: { display: false, stepSize: 5, },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
      y: {
        min: -8,
        max: 56,
        ticks: { display: false, stepSize: 5 },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
    } 
  }
}

let zoneImage = new Image()
zoneImage.src = zone
export const KZoneConfig2 = {
  plugins: [
    {
      id: 'custom_canvas_zone_image',
      beforeDraw: (chart) => {
        if (zoneImage.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
          var image_rwd_width = window.innerWidth * zoneImage.width / 1920 / 6.4;
          var image_rwd_height = window.innerWidth * zoneImage.height / 1920 / 6.6;
          const x = left + width / 2 - image_rwd_width / 2;
          const y = top + height - image_rwd_height - (16 * window.innerWidth / 1920);
          ctx.drawImage(zoneImage, x, y, image_rwd_width, image_rwd_height);
        } else {
          zoneImage.onload = () => chart.draw();
        }
      }
    },
  ],
  options: {
    responsive: true,  
    aspectRatio: 1,
    maintainAspectRatio: true,
    layout: {
      padding: {
        left: 50,
        bottom: 20,
      },
    },
    legend: {
      position: 'left',
      display: false
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
      },
      tooltip: false,
      datalabels: false
    },
    elements: {
      point: {
        pointRadius: 4,
      },
    },
    scales: {
      x: {
        min: -40,
        max: 40,
        ticks: { display: false, stepSize: 5, },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
      y: {
        min: -10,
        max: 70,
        ticks: { display: false, stepSize: 5 },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
    } 
  }
}

export const IntegrateKZoneConfig = {
  plugins: [
    {
      id: 'custom_canvas_zone_image',
      beforeDraw: (chart) => {
        if (zoneImage.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
          var image_rwd_width = window.innerWidth * zoneImage.width / 1920 / 6.4 * 1;
          var image_rwd_height = window.innerWidth * zoneImage.height / 1920 / 6.6 * 1;
          const x = left + width / 2 - image_rwd_width / 2;
          const y = top + height - image_rwd_height - (30 * window.innerWidth / 1920);
          ctx.drawImage(zoneImage, x, y, image_rwd_width, image_rwd_height);
        } else {
          zoneImage.onload = () => chart.draw();
        }
      }
    },
  ],
  options: {
    responsive: true,  
    aspectRatio: 1,
    maintainAspectRatio: true,
    legend: {
      display: false
    },
    plugins: {
      legend: false,
      tooltip: false,
      datalabels: false
    },
    elements: {
      point: {
        pointRadius: 4,
      },
    },
    scales: {
      x: {
        min: -33,
        max: 33,
        ticks: { display: false, stepSize: 5, },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
      y: {
        min: -14.5,
        max: 51.5,
        ticks: { display: false, stepSize: 5 },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
    } 
  }
}

export const IntegrateKZoneConfig2 = {
  plugins: [
    {
      id: 'custom_canvas_zone_image',
      beforeDraw: (chart) => {
        if (zoneImage.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
          // console.log(top, left, width, height)
          var image_rwd_width = window.innerWidth * zoneImage.width / 1920 / 6.4 * 1.35;
          var image_rwd_height = window.innerWidth * zoneImage.height / 1920 / 6.8 * 1.35;
          // console.log(image_rwd_height, image_rwd_width)
          const x = left + width / 2 - image_rwd_width / 2;
          const y = top + height - image_rwd_height - (20 * window.innerWidth / 1920);
          ctx.drawImage(zoneImage, x, y, image_rwd_width, image_rwd_height);
        } else {
          zoneImage.onload = () => chart.draw();
        }
      }
    },
  ],
  options: {
    responsive: true,  
    aspectRatio: 1,
    maintainAspectRatio: true,
    legend: {
      display: false
    },
    plugins: {
      legend: false,
      tooltip: true,
      datalabels: false
    },
    elements: {
      point: {
        pointRadius: 4,
      },
    },
    scales: {
      x: {
        min: -36,
        max: 36,
        ticks: { display: false, stepSize: 5, },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
      y: {
        min: -9.75,
        max: 66.25,
        ticks: { display: false, stepSize: 5 },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
    } 
  }
}

let fieldImage = new Image()
fieldImage.src = field
export const FieldConfig = {
  plugins: [
    {
      id: 'custom_canvas_hitter_line_image',
      beforeDraw: (chart) => {
        if (fieldImage.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
          var image_rwd_width = window.width * fieldImage.width / 1920;
          var image_rwd_height = window.width * fieldImage.height / 1920;
          const x = left;
          const y = top;
          ctx.drawImage(fieldImage, x, y, width, height);
        } else {
          fieldImage.onload = () => chart.draw();
        }
      }
    }
  ], 
  options: {
    responsive: true,
    aspectRatio: 0.95,
    layout: {
      padding: {
        bottom: 60,
      },
    },
    legend: {
      position: 'left',
      display: false
    },
    plugins: {
      legend: false,
      tooltip: false,
      datalabels: false
    },
    elements: {
      point: {
        pointRadius: 3,
      },
    },
    scales: {
      x: {
        min: -400,
        max: 400,
        ticks: { display: false, stepSize: 100, },
        grid: {
          display: true,
          drawTicks: false,
          borderWidth: 0
        },
      },
      y: {
        min: -100,
        max: 500,
        ticks: { display: false, stepSize: 100 },
        grid: {
          display: true,
          drawTicks: false,
          borderWidth: 0
        },
      },
    }
  },
}

export const PitchPortionConfig = {
  options: {
    responsive: true,
    aspectRatio: 0.95,
    legend: {
      display: false
    },
    plugins: {
      legend: false,
      tooltip: {
        display: true,
        padding: 8,
        callbacks: {
          label: (context) => (context.label+' '+context.raw+'%')
        },
      },
      datalabels: false
    },
  }
}

export const ZoneAreaBreakOutConfig = {
  options: {
    indexAxis: "y",
    scales: {
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: false,
        grid: {
          display: false,
          drawBorder: false
        }
      },
      x: {
        stacked: true,
        ticks: {
          display: false
        },
        grid: {
          display: false,
          drawBorder: false
        },
        min: -110,
        max: 110,
      }
    },
    elements: {
      bar: {
        borderWidth: 2
      }
    },
    responsive: true,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: true,
        text: "Swing / Take"
      }
    }
  }
};

let image2 = new Image();
image2.src = field2;
export const hpos_config = {
  plugins: [
    {
      id: "custom_canvas_background_image",
      beforeDraw: (chart) => {
        if (image2.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
          //var image_rwd_width = window.innerWidth * 0.32;
          //var image_rwd_height = window.innerWidth * 0.32;
          const x = left;
          const y = top;
          // console.log(image_rwd_height, image_rwd_width)
          ctx.drawImage(image2, x, y, width, height);
        } else {
          image2.onload = () => chart.draw();
        }
      }
    }
  ],
  options: {
    resposive: true,
    aspectRatio: 1,
    plugins: {
      legend: {
        display: false,
        position: "top",
        fullSize: false,
        boxWidth: 20,
        maxWidth: 20
      },
      datalabels: false,
      tooltip: {
        display: true,
        padding: 12,
        callbacks: {
          beforeBody: (context) => {
            let infos = []
            infos.push(`賽事編號: ${context[0].raw.g}`)
            infos.push(`局數: ${context[0].raw.inn}`)
            infos.push(`投手: ${context[0].raw.p}`)
            infos.push(`打者: ${context[0].raw.b}`)
            infos.push(`擊球結果: ${context[0].raw.pr}`)
            return infos
          },
          label: (context) => (`(${getDecimalData(context.raw.x, 1, 1, '-')}, ${getDecimalData(context.raw.y, 1, 1, '-')})`),
        },
      }
    },

    elements: {
      point: {
        pointRadius: 4.5,
        borderWidth: 1.5,
        borderColor: 'rgb(0,0,0)'
      }
    },
    scales: {
      x: {
        min: -300,
        max: 300,
        ticks: { display: false },
        title: {
          display: false
        },
        grid: {
          display: false,
          drawTicks: false,
          tickWidth: 0,
          drawBorder: false,
          borderWidth: 0
        }
      },
      y: {
        min: -90.35,
        max: 509.65,
        ticks: { display: false },
        title: {
          display: false
        },
        grid: {
          display: false,
          drawTicks: false,
          tickWidth: 0,
          drawBorder: false,
          borderWidth: 0
        }
      }
    }
  }
};

export const BatterScoreLogsTrendOptions = {
  aspectRatio: 1.1,
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    position: 'left',
    display: false
  },
  plugins: {
    legend: {
      display: true,
      position: 'top',
    },
    tooltip: true,
    datalabels: false
  },
  elements: {
    point: {
      pointRadius: 4,
    },
    line: {
      borderWidth: 2,
    }
  },
  scales: {
    x: {
      type: "linear",
      min: 0,
      suggestMax: 21,
      ticks: {
        stepSize: 1, display: true,
        callback: function (val, index) {
          // console.log(val, index)
          return val === 0 ? "" : val*2-1;
        }
      },
      title: {
        display: true,
        text: '週',
        align: 'end',
      },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: true,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
    y: {
      suggestMin: 0,
      suggestMax: 1,
      ticks: {
        display: true,
        stepSize: 0.1,
      },
      grid: {
        drawTicks: false,
        drawBorder: true,
        tickWidth: 0,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
  }
}